import { render, staticRenderFns } from "./ModifyChildren.vue?vue&type=template&id=53b100dd&"
import script from "./ModifyChildren.vue?vue&type=script&lang=js&"
export * from "./ModifyChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports